// 供销商邀请分销商组件
<template>
  <div class="text-center invite-distributor flex relative">
    <el-tabs v-model="activeName" type="card" class="tabs" :class="!needTab ? 'hidden' : ''">
      <el-tab-pane label="海报分享" name="first">
        <div class="goods-type flex align-center space-between" v-loading="loading">
          <div class="flex">
            <div class="text-bold">海报商品</div>
            <div class="mgl12">
              全部商品
              <span class="text-orange">
                {{goodsTypeMap.allCount}}
              </span>
            </div>
            <div class="mgl12">
              公开
              <span class="text-orange">
                {{goodsTypeMap.publicCount}}
              </span>
            </div>
            <div class="mgl12">
              私密
              <span class="text-orange">
                {{goodsTypeMap.privacyCount}}
              </span>
            </div>
            <el-popover
              placement="top"
              width="320"
              trigger="hover"
            >
              <div>
                若私密（分销商可见）商品设为公开（所有人可见），可增加更多曝光、合作机会
                <a href="/supplier/commodity/myShop?privacyState=1" target="_blank">去设置</a>
              </div>
              <i slot="reference" class="el-icon-bangzhuzhongxin mgl8"></i>
            </el-popover>
          </div>
          <el-button
            v-if="goodsList.length === 0"
            type="link"
            @click="addGoods"
          >
            添加商品
          </el-button>
          <el-popover
            v-else
            v-model="popoverShow"
          >
            <div>
              <SetGoodsRange
                ref="setGoodsRange"
                @handleChoose="handleChoose"
                @updateGoodsRange="updateGoodsRange"
                @close="handleClose"
                @openChooseGoods3="openDialog"
                @searchGoods="getShopItems"
              />
            </div>
            <el-button
              type="link"
              slot="reference"
              style="font-weight: 500;"
            >
              设置商品范围
            </el-button>
          </el-popover>
        </div>
        <div class="text-999 text-left mgb8 flex align-center space-between">
          <div>
            最多展示10张小店商品图
          </div>
          <div v-if="editing">
            <el-button
              type="link"
              @click="saveEdit"
            >
              保存编辑
            </el-button>
          </div>
          <div v-else-if="goodsList.length">
            <el-button
              type="link"
              @click="openSetPosterStyleDialog"
            >
              变更海报背景模版
            </el-button>
            <el-button
              type="link"
              @click="openDialog"
            >
              更换海报商品
            </el-button>
            <el-button
              type="link"
              @click="startEditing"
            >
              编辑海报商品
            </el-button>
          </div>
        </div>
        <!-- 海报模版 -->
        <component
          :is="templateMap[templateId]"
          :canvasId="canvasId"
          :maxHeight="maxHeight"
          :cardName="cardName"
          :wxCodeUrl="wxCodeUrl"
          :editing="editing"
          :goodsList="goodsList"
          :editingGoodsList="editingGoodsList"
          @deleteGoods="deleteGoods"
          @moveUp="moveUp"
          @moveDown="moveDown"
        />
      </el-tab-pane>
      <template v-if="needTab">
        <el-tab-pane label="分享到微信" name="second">
          <div>
            <div class="step-bg mgt16 relative">
              <div class="step absolute">step1</div>
              <div class="step1 flex align-center space-around pd16">
                <div>微信扫一扫，进入店铺小程序</div>
                <div class="code-wrapper">
                  <img width="100%" src="@/assets/images/mini_code.png" alt="">
                </div>
              </div>
            </div>
            <div class="step-bg mgt16 relative">
              <div class="step absolute">step2</div>
              <div class="step1 flex align-center space-around pd16">
                <div>分享小程序给好友</div>
                <img width="200px" src="https://img.alicdn.com/imgextra/i1/2211227103034/O1CN01dk13b91YHcRZplkLz_!!2211227103034.png" alt="">
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="分享到朋友圈" name="third">
          <div v-loading="loading">
            <div class="step-bg mgt16 relative">
              <div class="step absolute">step1</div>
              <div class="step1 flex align-center space-around pd16">
                <div>
                  下载推广海报
                  <el-link class="mgl8" @click="downloadPoster" icon="el-icon-download">下载</el-link>
                </div>
                <img width="185px" src="https://img.alicdn.com/imgextra/i3/2211227103034/O1CN01JJ404q1YHcRWgJEyC_!!2211227103034.png" alt="">
              </div>
            </div>
            <div class="step-bg mgt16 relative">
              <div class="step absolute">step2</div>
              <div class="step1 flex align-center space-around pd16">
                <div>将海报分享到朋友圈</div>
                <img width="185px" src="https://img.alicdn.com/imgextra/i3/2211227103034/O1CN01s7MP5G1YHcRVtpIGC_!!2211227103034.png" alt="">
              </div>
            </div>
          </div>
        </el-tab-pane>
      </template>
    </el-tabs>

    <!-- 隐藏的海报，下载用 -->


    <!-- 添加商品 -->
    <ImportGoods
      ref="importGoods"
      @callback="refreshGoodsList"
    />
    <SetPosterStyle
      ref="setPosterStyle"
      @changePosterTemplat="changePosterTemplat"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get, cloneDeep } from "lodash";
import { generateQrCodeUrl } from '@/api/distributor';
import { PLATFORM_ICONS_MAP } from '@/dictionary/platforms.js';
import html2canvas from 'html2canvas'
import { disInviteSupplierUrl, queryItemRuleInfo,queryDmsCompanyInfo } from '@/api/supplier';
import ImportGoods from '@/components/invite/ImportGoods'
import SetPosterStyle from '@/components/invite/SetPosterStyle'
import { getShopItemList } from '@/servers/commodity/index.js'
import SetGoodsRange from './SetGoodsRange.vue';
import DefaultPosterTemp from './DefaultPosterTemp.vue';
import NewYearsGoodsFestivalTemp from './NewYearsGoodsFestivalTemp.vue';
import { getMainImage } from '@/utils/index';
import no_pic from "@/assets/images/no_pic.png";

export default {
  components: {
    ImportGoods,
    SetGoodsRange,
    SetPosterStyle,
    DefaultPosterTemp,
    NewYearsGoodsFestivalTemp,
  },
  props: {
    needTab: {
      default: true,
      type: Boolean,
    },
    maxHeight: {
      default: 'fit-content',
      type: String,
    },
    type: {
      default: 'inviteDistributor',
      type: String,
    },
    canvasId: {
      default: 'poster',
      type: String,
    },
    cardName: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      PLATFORM_ICONS_MAP,
      wxCodeUrl: '',
      form: {
        link: `${window.location.origin}/distributor/supplier/mine?`,
      },
      activeName: 'first',
      goodsList: [],
      editingGoodsList: [],
      editing: false,
      // 商品范围
      goodsRange: 1,
      loading: false,
      goodsTypeMap: {
        allCount: 0,
        privacyCount: 0,
        publicCount: 0
      },
      popoverShow: false,
      outerIds: [],
      templateId:'1',
      templateMap:{
        '1':'DefaultPosterTemp',
        '2':'NewYearsGoodsFestivalTemp'
      }
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
    ]),
  },
  mounted() {
    this.getShopItems();
    this.getWxCodeUrl();
    this.handleGetDmsCompanyInfo();
    this.getDmsCompanyInfo();
  },
  watch: {
    goodsRange(newVal) {
      if (newVal === 1) {
        this.getShopItems();
      }
    },
    goodsList(newVal) {
      this.$emit('getBtnDisabled', newVal.length === 0);
      if(newVal.length === 0){ // 关闭弹窗
        this.handleClose();
      }
    }
  },
  methods: {
    initData() {
      this.goodsList = [];
      this.editingGoodsList = [];
      this.editing = false;
      this.goodsTypeMap = {
        allCount: 0,
        privacyCount: 0,
        publicCount: 0
      };
      this.goodsRange = 1;
      this.activeName = 'first';
      this.getShopItems();
      this.getWxCodeUrl();
      this.handleGetDmsCompanyInfo();
    },
    async getWxCodeUrl() {
      // 分享小店和邀请分销商两种情况
      const cacheKey = this.type === 'shareShop' ? 'wxCodeUrl' : 'WxCodeUrlInvitation';
      const params = {
        path: 'supplier/list/index',
        params: JSON.stringify({
          supplierCompanyId: this.userInfo.companyId,
          fromLoginIdentity: 1,
          ...(this.type !== 'shareShop' && { invitation: 1 })
        }),
        envVersion: 'release', // release -正式版 trial - 体验版 develop-开发版
        width: 144
      };

      // 优先从缓存获取
      let url = sessionStorage.getItem(cacheKey);

      //看缓存有没有对应的code，有的情况不再请求
      if (!url) {
        try {
          const res = await generateQrCodeUrl(params);
          url = get(res, 'data', '');
          // 缓存二维码URL，避免重复生成超过微信调用限制
          if (url) {
            sessionStorage.setItem(cacheKey, url);
          }
        } catch (error) {
          console.error('获取二维码失败:', error);
        }
      }

      this.wxCodeUrl = url;
    },

    // 获取小店商品
    async getShopItems(params={}) {
      this.loading = true;
      let res = await getShopItemList({
        ...params,
        pageNo: 1,
        pageSize: 10,
      })
      if (res) {
        this.goodsList = res.records;
        this.calculateItemRules(null,params);
      }
      this.loading = false;
    },

    async handleGetDmsCompanyInfo() {
      try {
        const res = await disInviteSupplierUrl();
        // const { companyId, needAudit, companyName } = res.data;
        this.form = {
          link: res.data
        };
      } catch (error) {
        console.log("error: ", error);
      }
    },

    downloadPoster() {
      this.loading = true;
      let container = document.getElementById(this.canvasId);
      html2canvas(container, {
        width: container.clientWidth / 10,
        height: container.clientHeight / 10,
        useCORS: true,
        allowTaint: true,
        scale: 50,
        dpi: 300,
      }).then(canvas => {
        let src = canvas.toDataURL('image/jpg', 1);
        let image = new Image()
        image.src = src
        image.style.verticalAlign = 'middle';
        image.setAttribute('crossOrign', 'Anonymous');
        let url = image.src.replace(/^data:image\/[^;]/, 'data:application/octet-stream')
        let a = document.createElement('a')
        a.download = `${this.userInfo.companyName}邀您看精选好货.jpg` // 设置下载的文件名，默认是'下载'
        a.href = url
        document.body.appendChild(a)
        a.click()
        a.remove() // 下载之后把创建的元素删除
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    },

    addGoods() {
      this.$refs.importGoods.method_open();
    },

    /**
     * @params changeRange - 是否更换了商品范围
     * 
     */
    handleChoose(arr, changeRange) {
      if (!arr.length) {
        this.$message.warning('当前未选择任何商品');
        return;
      }
      this.goodsList = arr;
      if ((changeRange !== this.goodsRange) || this.goodsRange === 3) {
        // 如果原本不是指定商品范围，现在选择了指定商品范围，或者原本已经是指定商品，再更换了商品范围，那需要改变商品范围
        if (changeRange === 3) {
          this.outerIds = arr.map(item => item.outerId);
        }
        this.calculateItemRules(changeRange);
      }
    },

    // 计算公开宝贝数和私密宝贝数
    async calculateItemRules(changeRange,data={}) {
      let queryType = changeRange || this.goodsRange;
      let params = {
        queryType,
      }
      if (queryType === 3) {
        // 指定商品
        params.outerIds = this.outerIds;
      }
      if(queryType === 4){
        params.displayCode = data.displayCode
      }
      let res = await queryItemRuleInfo(params);
      this.goodsTypeMap = res.data;
    },

    openDialog() {
      let params = {
        goodsRange: this.goodsRange,
      };
      if (this.goodsRange === 3) {
        params = {
          goodsRange: 3,
          initialParams: {
            outerIds: this.outerIds.join(','),
          }
        }
      }
      this.$refs.setGoodsRange.openDialog('edit', params);
    },
    openSetPosterStyleDialog(){
      this.$refs.setPosterStyle.openDialog();
    },

    startEditing() {
      this.editing = true;
      this.editingGoodsList = cloneDeep(this.goodsList);
      this.$emit('edit', true);
    },

    deleteGoods(index) {
      this.editingGoodsList.splice(index, 1);
    },

    moveUp(index) {
      let arr = this.editingGoodsList;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
    },
    moveDown(index) {
      let arr = this.editingGoodsList;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
    },

    saveEdit() {
      this.goodsList = cloneDeep(this.editingGoodsList);
      this.editing = false;
      this.$emit('edit', false);
    },

    updateGoodsRange(value) {
      this.goodsRange = value;
      if (value === 1) {
        this.outerIds = [];
      }
    },

    copyShareLink() {
      this.$copyText(this.form.link).then((e) => {
        this.$message.success('复制成功');
      }, function (e) {
        console.error(e);
        this.$message.error('复制失败');
      })
    },

    handleClose(show = false) {
      this.popoverShow = show;
    },

    refreshGoodsList() {
      this.getShopItems();
    },
    getMainImage,
    imgOnError(e) {
      console.log(e);
      let img = e.srcElement;
      img.src = no_pic;
      img.onerror = null; //防止闪图
    },
    changePosterTemplat(templateId){
        this.templateId = templateId
    },
    async getDmsCompanyInfo(){
      let res = await queryDmsCompanyInfo();
      if(res.result === 1){
         this.templateId = res.data.posterBgTemplate || '1';
      }
    },
  }
}

</script>

<style lang='scss' scoped>
  .invite-distributor {
    .tabs {
      width: 520px;
      background-color: #fff;
      &.hidden {
        ::v-deep .el-tabs__header {
          display: none;
        }
      }
    }
  }

  .goods-type {
    height: 36px;
    background-color: #F5F6F7;
    margin-bottom: 12px;
    padding-left: 12px;
  }
  .poster-content {
    width: 520px;
    background: linear-gradient(315deg, #9dc7ff 23%, rgb(222, 241, 255) 74%);
    padding: 32px;
    height: fit-content;
    // max-height: calc(100vh - 240px);
    overflow-y: auto;
    box-shadow: inset 0px -8px 10px 0px rgba(0, 0, 0, 0.06);
    &.hide {
      // width: 520px;
      height: fit-content;
      max-height: fit-content;
      transform: scale(0.1) translateY(-250%);
      top: -50%;
      left: 0;
      z-index: -1;
    }

    .poster-goods-item {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 16px;
      margin-bottom: 8px;
      .remove-icon {
        top: 2px;
        right: 2px;
      }
      .move-icon {
        top: 50%;
        transform: translateY(-50%);
        right: -24px;
      }
      .discounts {
        background-color: #fd88441f;
        padding: 3px 0;
        text-align: center;
      }
      .poster-goods-item-text {
        width: 300px;
        height: 106px;
        display: flex;
        flex-direction: column;
        text-align: left;
        justify-content: space-between;
      }

      .recommend-tag {
        top: 0;
        left: 0;
        color: #fff;
        width: 38px;
        height: 20px;
        line-height: 20px;
        background: #2695FA;
        text-align: center;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .step-bg {
    background-color: #F5F6F7;
    .code-wrapper {
      width: 94px;
      height: 94px;
      padding: 4px;
      box-sizing: border-box;
      border-radius: 6px;
      background-color: #fff;
    }
    .step {
      background-color: #2695FA;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      top: 16px;
      left: 0;
      color: #fff;
      width: 60px;
      text-align: center;
      padding: 2px 0;
      font-weight: 550;
    }
  }
</style>
